import _createForOfIteratorHelper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.some.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { __decorate } from "tslib";
import Draggable from 'vuedraggable';
import { Component, Prop, Vue } from 'vue-property-decorator';
import Pagination from '@/components/Pagination/index.vue';
import { updateMissionInfoSettings } from '@/api/missionInfoSetting';
import { getMissionInfos } from '@/api/missionInfo';
import { handArmFunctions, missionTypes } from '@/utils/constants';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "setting", void 0);
    _defineProperty(_this, "visible", void 0);
    _defineProperty(_this, "total", 0);
    _defineProperty(_this, "missionTypes", missionTypes);
    _defineProperty(_this, "handArmFunctions", handArmFunctions);
    _defineProperty(_this, "listQuery", {
      page: 1,
      type: '',
      day: undefined,
      handArmFunction: '',
      limit: 10,
      title: undefined
    });
    _defineProperty(_this, "selectList", []);
    _defineProperty(_this, "selectedList", []);
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "resetDraggable",
    value: function resetDraggable(items) {
      var _this2 = this;
      items.forEach(function (d) {
        if (_this2.isInSelected(d)) {
          d.draggable = false;
        } else {
          d.draggable = true;
        }
      });
      return items;
    }
  }, {
    key: "getList",
    value: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getMissionInfos(this.listQuery);
            case 1:
              data = _context.v;
              this.selectList = this.resetDraggable(data.items);
              this.total = data.total;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }()
  }, {
    key: "isInSelected",
    value: function isInSelected(v) {
      return this.selectedList.some(function (k) {
        return v.id === k.id;
      });
    }
  }, {
    key: "deleteSelected",
    value: function deleteSelected(ele) {
      var _iterator = _createForOfIteratorHelper(this.selectedList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.id === ele.id) {
            var index = this.selectedList.indexOf(item);
            this.selectedList.splice(index, 1);
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.selectList = this.resetDraggable(this.selectList);
    }
  }, {
    key: "isFree",
    value: function isFree(free) {
      if (free === undefined || free === null || free === false) {
        return false;
      }
      return true;
    }
  }, {
    key: "handleSearch",
    value: function handleSearch() {
      this.listQuery.page = 1;
      this.getList();
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.$emit('update:visible', false);
    }
  }, {
    key: "handleOpen",
    value: function handleOpen() {
      var handArmFunction = this.setting.hand_arm_function;
      this.listQuery.handArmFunction = handArmFunction;
      this.selectedList = this.setting.missions.map(function (s) {
        return {
          id: s.mission_info_id,
          handArmFunction: handArmFunction,
          type: s.type,
          title: s.title,
          image: '',
          description: '',
          createdAt: new Date(),
          links: [],
          tags: [],
          isFree: s.isFree
        };
      });
      this.getList();
    }
  }, {
    key: "handleSelectedUpdate",
    value: function handleSelectedUpdate() {
      this.selectList = this.resetDraggable(this.selectList);
    }
  }, {
    key: "updateData",
    value: function () {
      var _updateData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var missions, _iterator2, _step2, item, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              missions = [];
              _iterator2 = _createForOfIteratorHelper(this.selectedList);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  item = _step2.value;
                  missions.push({
                    type: item.type,
                    mission_info_id: item.id,
                    title: item.title
                  });
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              data = {
                sequence: this.setting.sequence,
                hand_arm_function: this.setting.hand_arm_function,
                missions: missions
              };
              _context2.n = 1;
              return updateMissionInfoSettings(data);
            case 1:
              this.$notify({
                title: 'Update',
                message: 'Successfully Updated',
                type: 'success',
                duration: 2000
              });
              this.handleClose();
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }]);
}(Vue);
__decorate([Prop({
  required: false
})], default_1.prototype, "setting", void 0);
__decorate([Prop({
  required: false
})], default_1.prototype, "visible", void 0);
default_1 = __decorate([Component({
  name: 'Edit',
  components: {
    Pagination: Pagination,
    Draggable: Draggable
  },
  filters: {
    typeLabel: function typeLabel(type) {
      return type != null && type === 'BASICS' ? 'EXERCISE' : type;
    }
  }
})], default_1);
export default default_1;